const prepareSortOptionsReports = (keys, desc, keyMap) => {
    let sortOptions = []

    keys.forEach((key, index) => {
        let direction = desc[index] ? 'desc' : 'asc'
        sortOptions.push(`${keyMap[key]}_${direction}`)
    })
    return sortOptions
}

export default prepareSortOptionsReports
